<template>
  <div class="MaterialUploadModal">
    <el-dialog
        title=""
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :append-to-body="true"
        @open="handleOpen"
        width="30%"
    >
      <div class="contentBox">
        <el-form ref="form" size="mini" label-width="90px" style="width: 100%">
          <el-form-item :label='materialType==="text2"?"问题:":"名称:"' prop="name">
            <el-input
                class="nameInput"
                placeholder="请输入名称"
                v-model="name"
            ></el-input>
          </el-form-item>

          <template v-if="materialType === 'image'">
            <el-form-item label="图片：">
              <div class="itemBox">
                <el-upload
                    v-if="editMode==='add'"
                    v-loading="loading"
                    element-loading-text="上传中，请勿操作"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    action="#"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="handleImgChange"
                    :before-upload="beforeImageUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div>
                    <el-button
                        class="btn"
                        v-if="imageUrl"
                        size="mini"
                        plain
                        type="primary"
                        slot="trigger"
                    >重新上传
                    </el-button>
                    <el-button
                        class="btn"
                        v-else
                        size="mini"
                        type="primary"
                        slot="trigger"
                    >上传图片
                    </el-button>
                  </div>
                </el-upload>
                <div v-else>
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
                </div>
              </div>
            </el-form-item>
          </template>
          <template v-if="materialType === 'audio'">
            <el-form-item label="音频:">
              <template v-if="audioUrl">
                <audio
                    class="materialCardAudio"
                    :src="audioUrl"
                    :loop="false"
                    controls
                    preload="auto"
                    controlsList="nodownload noplaybackrate"
                ></audio>
                <!--                <video-->
                <!--                  style="width: 400px; height: 200px"-->
                <!--                  controls-->
                <!--                  :src="videoUrl"-->
                <!--                />-->
                <div style="text-align: right; width: 400px">
                  <el-button
                      v-if="editMode==='add'"
                      class="btn"
                      size="mini"
                      type="primary"
                      @click="handleUploadNewAudio"
                  >重新上传
                  </el-button>
                </div>
              </template>
              <template v-else>
                <el-upload
                    v-loading="loading"
                    element-loading-text="上传中，请勿操作"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    drag
                    action="#"
                    :auto-upload="false"
                    :show-file-list="false"
                    :before-upload="beforeUploadAudio"
                    :on-change="handleAudioChange"
                >
                  <i class="el-icon-upload"></i>
                  <div>
                    <el-button
                        class="btn"
                        size="mini"
                        type="primary"
                        slot="trigger"
                    >上传音频
                    </el-button>
                  </div>
                </el-upload>
              </template>
            </el-form-item>
          </template>
          <template v-if="materialType === 'video'">
            <el-form-item label="视频:">
              <template v-if="videoUrl">
                <div>
                  <y-j-video style="width: 400px; height: 200px"
                             :src="videoUrl"
                  />
                </div>
                <div style="text-align: right; width: 400px">
                  <el-button
                      v-if="editMode==='add'"
                      class="btn"
                      size="mini"
                      type="primary"
                      @click="handleUploadNewVideo"
                  >重新上传
                  </el-button>
                </div>
              </template>
              <template v-else>
                <el-upload
                    v-loading="loading"
                    element-loading-text="上传中，请勿操作"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    drag
                    action="#"
                    :auto-upload="false"
                    :show-file-list="false"
                    :before-upload="beforeUploadVideo"
                    :on-change="handleVideoChange"
                >
                  <i class="el-icon-upload"></i>
                  <div>
                    <el-button
                        class="btn"
                        size="mini"
                        type="primary"
                        slot="trigger"
                    >上传视频
                    </el-button>
                  </div>
                </el-upload>
              </template>
            </el-form-item>
          </template>
          <template v-if="materialType === 'text'">
            <el-form-item label="描述:" prop="content">
              <el-input
                  class="textInput"
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="content"
              ></el-input>
            </el-form-item>
          </template>
          <template v-if="materialType === 'text2'">
            <el-form-item label="回答:" prop="content">
              <el-input
                  class="textInput"
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="content"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div class="footer">
        <el-button
            style="width: 80px"
            type="primary"
            @click="handleConfirm"
            :disabled="!canSave"
        >确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapActions, mapState} from "vuex";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "MaterialModal",
  components: {YJVideo},
  props: {
    materialType: {
      type: String,
      default() {
        return "image";
      },
    },
    materialInfo: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      name: null,
      filename: null,
      imageUrl: "",
      audioUrl: "",
      videoUrl: "",
      content: "",
      editMode: "add",
      loading: false,
    };
  },
  created() {
  },
  computed: {
    ...mapState("tenant", ["ossUploadObj"]),
    visible: {
      get() {
        return this.$store.state.courseCenter.materialUploadVisible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "materialUploadVisible",
          value,
        });
      },
    },
    canSave: {
      get() {
        if (this.materialType === "image") {
          return (
              this.name != null &&
              this.name != "" &&
              this.filename != null &&
              this.filename != ""
          );
        } else if (this.materialType === "audio") {
          return (
              this.name != null &&
              this.name != "" &&
              this.filename != null &&
              this.filename != ""
          );
        } else if (this.materialType === "video") {
          return (
              this.name != null &&
              this.name != "" &&
              this.filename != null &&
              this.filename != ""
          );
        } else {
          // if (this.materialType == "text")
          return (
              this.name != null &&
              this.name != "" &&
              this.content != null &&
              this.content != ""
          );
        }
      },
    },
  },
  methods: {
    ...mapActions("courseCenter", [
      "searchMaterialResource",
      "saveMaterialResource",
      "deleteMaterialResource",
      "searchDisease",
      "saveDisease",
      "deleteDisease",
    ]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    ...mapMutations("courseCenter", ["setData"]),
    handleOpen() {
      this.name = null;
      this.filename = null;
      this.imageUrl = null;
      this.audioUrl = null;
      this.videoUrl = null;
      this.content = null;
      if (this.materialInfo != null) {
        console.log(this.materialInfo)
        if (this.materialType === "image") {
          this.imageUrl = this.materialInfo.url;
          this.filename = this.materialInfo.filename;
          this.name = this.materialInfo.name;
        } else if (this.materialType === "audio") {
          this.audioUrl = this.materialInfo.url;
          this.filename = this.materialInfo.filename;
          this.name = this.materialInfo.name;
        } else if (this.materialType === "video") {
          this.videoUrl = this.materialInfo.url;
          this.filename = this.materialInfo.filename;
          this.name = this.materialInfo.name;
        } else {
          this.name = this.materialInfo.title;
          this.content = this.materialInfo.content;
        }
        this.editMode = "edit";
      } else {
        this.editMode = "add";
      }
    },
    handleConfirm() {
      this.saveData();
    },
    async saveData() {
      if (this.materialType === "text") {
        await this.saveDisease({
          id: this.editMode === "add" ? null : this.materialInfo.id,
          title: this.name,
          content: this.content,
          type: 1,
        });
      } else if (this.materialType === "text2") {
        await this.saveDisease({
          id: this.editMode === "add" ? null : this.materialInfo.id,
          title: this.name,
          content: this.content,
          type: 2,
        });
      } else {
        await this.saveMaterialResource({
          id: this.editMode === "add" ? null : this.materialInfo.id,
          name: this.name,
          filename: this.filename,
        });
      }
      this.$emit("refreshMaterialList");
      this.setData({key: "materialUploadVisible", value: false});
    },
    //图片
    async handleImgChange(file) {
      this.loading = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
            this.imageUrl = URL.createObjectURL(file.raw);
            this.filename = this.ossUploadObj.filename;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.$message.error("图片上传失败，请重新上传");
            this.imageUrl = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    // 音频
    beforeUploadAudio(file) {
      if (file.name.split(".")[1].toLowerCase() !== "mp3") {
        this.$message.error("上传音频仅支持mp3格式");
        return false; // 终止上传
      }
    },
    async handleAudioChange(file) {
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (isJPG !== "mp3") {
        this.$message.error("上传视频只能是 MP3格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then(() => {
            this.audioUrl = URL.createObjectURL(file.raw);
            this.filename = this.ossUploadObj.filename;
            // 获取音频时长
            const audio = document.createElement("audio");
            audio.src = URL.createObjectURL(file.raw);
            audio.addEventListener("loadedmetadata", () => {
            });
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("音频上传失败，请重新上传");
            this.audioUrl = "";
            console.log(e);
          });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewAudio() {
      this.audioUrl = "";
    },

    // 视频
    beforeUploadVideo(file) {
      if (file.name.split(".")[1].toLowerCase() !== "mp4") {
        this.$message.error("上传视频仅支持mp4格式");
        return false; // 终止上传
      }
    },
    async handleVideoChange(file) {
      console.log("handleVideoChange");
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (isJPG !== "mp4") {
        this.$message.error("上传视频只能是 MP4格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
            this.videoUrl = URL.createObjectURL(file.raw);
            this.filename = this.ossUploadObj.filename;
            // 获取视频时长
            const video = document.createElement("video");
            video.src = URL.createObjectURL(file.raw);
            video.addEventListener("loadedmetadata", () => {
            });
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("视频上传失败，请重新上传");
            this.videoUrl = "";
            console.log(e);
          });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewVideo() {
      this.videoUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
//.MultiContentModal {
::v-deep .el-dialog {
  min-width: 580px;
  min-height: 440px;
  position: relative;
  margin-top: 10vh !important;

  .el-dialog__header {
    box-shadow: none;
  }
}

::v-deep .el-upload-dragger {
  width: 300px;
}

::v-deep .el-textarea__inner {
  height: 200px;
}

.cardSelect {
  border: solid 2px blue;
}

.contentBox {
  min-width: 400px;
  padding: 10px;
  height: 300px;
  font-size: 16px;
  background: #fafafa;
  letter-spacing: 0.1em;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .contentRow {
  }

  .addButton {
    height: 36px;
    width: 500px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #10689c;
  }
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 20px;
  right: 50px;
}

.MaterialCenter {
  .appBox {
  }
}

.tabSelect {
  background-color: #10689c;
  color: white;
}

.tabUnSelect {
}

.materialContent {
  margin-top: 20px;
  height: 430px;
  width: 685px;
  background-color: #ddd;
  float: left;

  .materialCard {
    float: left;
    width: 17.6%;
    height: 130px;
    overflow: hidden;
    margin-left: 2%;
    margin-top: 10px;

    .materialCardImage {
      background-color: white;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .materialCardAudio {
      background-color: white;
      width: 100%;
      height: 100%;
    }

    .materialCardVideo {
      background-color: white;
      width: 100%;
      height: 100%;
    }

    .materialCardText {
      background-color: white;
      width: 100%;
      height: 100%;
      padding: 10px;

      .materialCardTextTitle {
        font-size: 14px;
      }

      .materialCardTextContent {
        padding-top: 10px;
        font-size: 12px;
        padding-bottom: 10px;
        height: 90%;
        overflow: hidden;
        color: #999;
      }
    }
  }
}

.pagenation {
  text-align: center;
  clear: both;
  margin-top: -10px;
  display: flex;
  justify-content: center;
}

.findInput {
  width: 200px;
  float: right;
}

.findButton {
  float: right;
  margin-left: 0px;
}

.addButton {
  float: right;
}

//}

//图片
.avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #dcdfe6;
  margin-bottom: 20px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  margin-bottom: 10px;
}

.nameInput {
  width: 300px;
}

.textInput {
  width: 300px;
  height: 200px;
}
</style>
